"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmallCaps = void 0;
var tslib_1 = require("tslib");
var React = (0, tslib_1.__importStar)(require("react"));
var text_1 = require("../text");
function SmallCaps(props) {
    var children = props.children, color = props.color;
    return (React.createElement(text_1.Text, { style: { letterSpacing: '1px', textTransform: 'uppercase', fontSize: '11px', lineHeight: '17px' }, color: color, weight: 600 }, children));
}
exports.SmallCaps = SmallCaps;
//# sourceMappingURL=index.js.map